const CONFIDENCE_VALUES = {
  HIGH: {
    className: 'sales-high',
    color: '#39B54A',
    label: 'High',
  },
  MEDIUM_HIGH: {
    className: 'sales-medium-high',
    color: '#8ABA14',
    label: 'Medium to High',
  },
  MEDIUM: {
    className: 'sales-medium',
    color: '#EFA000',
    label: 'Medium',
  },
  MEDIUM_LOW: {
    className: 'sales-medium-low',
    color: '#F0763E',
    label: 'Low to Medium',
  },
  LOW: {
    className: 'sales-low',
    color: '#FF0F0F',
    label: 'Low',
  },
  NONE: {
    className: 'none',
    color: '#787B7E',
    label: 'No',
  },
};

const CONFIDENCE_VALUES_RENTAL = {
  HIGH: {
    className: 'rental-high',
    color: '#7ED321',
    label: 'High',
  },
  MEDIUM: {
    className: 'rental-medium',
    color: '#F3B200',
    label: 'Medium',
  },
  LOW: {
    className: 'rental-low',
    color: '#FF1310',
    label: 'Low',
  },
  NONE: {
    className: 'none',
    color: '#787B7E',
    label: 'No',
  },
};

/**
 * Get confidence object values from AVM object returned from API
 * @param avm {{confidence: string, clapiConfidence: string}}
 * @param isRental
 * @returns {{color: string, className: string, label: string}}
 */
export function getConfidenceFromAvm(avm, isRental = false) {
    if (isRental) {
        return getRentalConfidenceFromAvm(avm);
    }
    return getSalesConfidenceFromAvm(avm);
}

export function getSalesConfidenceFromAvm(avm) {
    const confidence = avm?.clapiConfidence ?? avm?.confidence?.toLocaleUpperCase();
    if (avm?.fsd && avm?.fsd >= 25) {
        return CONFIDENCE_VALUES.NONE;
    }
    return CONFIDENCE_VALUES[confidence] ?? CONFIDENCE_VALUES.NONE;
}

export function getRentalConfidenceFromAvm(avm) {
    const fsd = avm?.fsd;
    if (fsd === null || fsd === undefined || fsd < 0 || fsd >= 30) {
        return CONFIDENCE_VALUES_RENTAL.NONE;
    } else if (fsd <= 8) {
        return CONFIDENCE_VALUES_RENTAL.HIGH;
    } else if (fsd <= 16) {
        return CONFIDENCE_VALUES_RENTAL.MEDIUM;
    } else {
        return CONFIDENCE_VALUES_RENTAL.LOW;
    }
}
